import {
  App,
  Button,
  Card,
  Col,
  DatePicker,
  Dropdown,
  Flex,
  Form,
  Input,
  Radio,
  Row,
  Select,
  Spin,
  TimePicker,
} from 'antd';
import { DownOutlined } from '@ant-design/icons';
import React, { useEffect, useState } from 'react';
import { getPatientDetails, getPatients } from '../../../network/patients';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { queryKeys } from '../../../services/react-query/queryKeys';
import {
  addAppointments,
  getAppointmentsDetails,
  getAppointmentTypes,
  getAvailableTimeSlots,
  getListTimeSlots,
  getSearchPatients,
  updateAppointments,
  updateAppointmentsWorkflow,
} from '../../../network/appointment';
import { useSelector } from 'react-redux';
import {
  getPractitioners,
  getPractitionersDetails,
} from '../../../network/practitioners';
import dayjs from 'dayjs';
import { useNavigate, useParams } from 'react-router-dom';
import ChangeStauts from '../../../hooks/ChangeStauts';
import { getTimeFormat } from '../../../utils/utils';
import { getValidPatientInsurancePolicies } from '../../../network/PatientInsurancePolicy';
import Heading from '../../common/Heading/Heading';
import PhoneInputWithCountrySelect, {
  parsePhoneNumber,
  isValidPhoneNumber,
} from 'react-phone-number-input';
import isBetween from 'dayjs/plugin/isBetween';

dayjs.extend(isBetween);

const AppointmentAdd = ({ t, edit, patient }) => {
  const { id } = useParams();
  const [searchTxt, setSearchTxt] = useState('');
  const [searchTxtPractitionerTxt, setSearchPractitionerTxt] = useState('');
  // console.log(patient, 'patient');
  const [loadingAdd, setLoadingAdd] = useState(false);
  const client = useQueryClient();
  const [disabledDays, setDisabledDays] = useState([]);
  const [form] = Form.useForm();
  const { message } = App.useApp();
  const navigate = useNavigate();
  const { darkMode } = useSelector((state) => state.user);
  const [valueTime, setValueTime] = useState();
  const [selectTimeSlots, setSelectTimeSlots] = useState([]);
  const [selectTimesNoAvailable, setSelectTimesNoAvailable] = useState([]);
  // console.log(selectTimesNoAvailable, 'selectTimesNoAvailablewqjdiqwjhfiwqhfihwqihfuiqwfhiwq');

  // console.log(valueTime, 'valueTime');
  // console.log(selectTimeSlots, 'selectTimeSlots');
  const watchApointmentDate = Form.useWatch('appointment_date', form);
  // console.log(watchApointmentDate, 'watchApointmentDate');

  const {
    mutate: onGetAvailableTimeSlots,
    isLoading,
    data: timeSlots,
  } = useMutation({
    // mutationFn: (body) => getAvailableTimeSlots(body),
    mutationFn: (body) => getListTimeSlots(body),
    // onSuccess: (data) => {
    //   console.log(data, 'data');
    //   if(dayjs().format('YYYY-MM-DD') === dayjs(watchApointmentDate).format('YYYY-MM-DD')){
    //     const  filterTime = data?.message?.slot_details[0]?.avail_slot?.filter(
    //       (item) => getTimeFormat(item?.from_time) >= dayjs().format("h:mm A")
    //     )
    //      setSelectTimeSlots(filterTime);
    //   }else{
    //     const listTime = data?.message?.slot_details[0]?.avail_slot;
    //     setSelectTimeSlots(listTime);
    //   }
    // },
    onSuccess: (data) => {
      // console.log(data, 'data');
      const slotDetails = data?.message?.slot_details;

      if (
        !slotDetails ||
        slotDetails.length === 0 ||
        !slotDetails[0]?.avail_slot?.length
      ) {
        message.error('No time slot available');
        setSelectTimeSlots([]);
        setDisabledDays((prev) => [
          ...prev,
          dayjs(watchApointmentDate).format('YYYY-MM-DD'),
        ]);
      } else if (
        dayjs().format('YYYY-MM-DD') ===
        dayjs(watchApointmentDate).format('YYYY-MM-DD')
      ) {
        const filterTime = slotDetails[0]?.avail_slot?.filter(
          (item) => getTimeFormat(item?.from_time) >= dayjs().format('h:mm A')
        );
        // console.log(slotDetails,"slotDetailsslotDetailsslotDetailsslotDetailsslotDetailsslotDetails");

        const filterTimeSelect = filterTime;
        setSelectTimeSlots(filterTime);
      } else {
        const listTime = slotDetails[0]?.avail_slot;
        setSelectTimeSlots(listTime);
      }
      const selectTimes = slotDetails[0]?.appointments?.map((item) => {
        const fromTime = dayjs(item?.appointment_time, 'HH:mm:ss');
        const duration = Number(item?.duration) - 1;
        const toTime = fromTime.add(duration, 'minute');
        return {
          from_time: fromTime.format('HH:mm:ss'),
          to_time: toTime.format('HH:mm:ss'),
        };
      });

      setSelectTimesNoAvailable(selectTimes);
      // console.log(selectTimes, 'selectTimesmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmm');
    },

    onError: (error) => {
      message.error('No time slot available');
      console.log(error, 'error');
      setSelectTimeSlots([]);
      setDisabledDays((prev) => [
        ...prev,
        dayjs(watchApointmentDate).format('YYYY-MM-DD'),
      ]);
    },
  });
  const { mutate: updateAppointmentStatus, isLoading: loadingUpdateStatus } =
    useMutation({
      mutationFn: (status) => updateAppointmentsWorkflow(status),
      onSuccess: (data) => {
        console.log(data, 'data');
        if (data?.message?.status === 500) {
          message.error(data?.message?.message);
          return false;
        }
        message.success(data?.message?.message || []);
        client.invalidateQueries({ queryKey: [queryKeys.practitioners, id] });
      },
      onError: (error) => {
        console.log(error, 'error');
      },
    });
  const { mutate: onAddAppointments } = useMutation({
    mutationKey: ['addAppointments'],
    mutationFn: (body) =>
      edit ? updateAppointments(body) : addAppointments(body),
    onSuccess: (data) => {
      console.log(data, 'datawwww');
      setLoadingAdd(false);
      if (data?.message?.status === 500) {
        message.error(data?.message?.message);
        return false;
      }
      message.success(edit ? 'Updated successfully' : 'Added successfully');
      client.invalidateQueries({ queryKey: [queryKeys.getAppointments] });
      form.resetFields();
      navigate('/appointments');
    },
    onError: (error) => {
      setLoadingAdd(false);
      console.log('error:', error);
      const serverMessages = JSON.parse(error.response.data._server_messages);
      const messageData = JSON.parse(serverMessages[0]);
      console.log(messageData, 'messageData');

      const title = messageData.title || 'Error';
      const messageContent = messageData.message || 'An error occurred';
      message.error({
        content: `${title}: ${messageContent.replace(/<[^>]*>/g, '')}`,
        duration: 5,
      });
    },
  });

  const onFinish = (values) => {
    setLoadingAdd(true);
    onAddAppointments({
      ...values,
      appointment_date: values.appointment_date.format('YYYY-MM-DD'),
      name: id,
    });
  };
  // const { data: patients } = useQuery({
  //   queryKey: [queryKeys.getPatients],
  //   queryFn: () => getPatients(1),
  //   keepPreviousData: true,
  // });
  const { data: patientsSearch, isLoading: isLoadingPatientSearch } = useQuery({
    queryKey: [queryKeys.getSearchPatients, searchTxt],
    queryFn: () => getSearchPatients('Patient', searchTxt),
    enabled: searchTxt?.length >= 2 || searchTxt?.length === 0,
    keepPreviousData: true,
  });
  const { data: practitionersSearch, isLoading: isLoadingPractitioners } =
    useQuery({
      queryKey: [queryKeys.getSearchPractitioners, searchTxt],
      queryFn: () =>
        getSearchPatients('Healthcare Practitioner', searchTxtPractitionerTxt),
      enabled:
        searchTxtPractitionerTxt?.length >= 2 ||
        searchTxtPractitionerTxt?.length === 0,
      keepPreviousData: true,
    });
  // const { data: practitioners } = useQuery({
  //   queryKey: [queryKeys.practitioners],
  //   queryFn: () => getPractitioners(),
  //   keepPreviousData: true,
  // });
  const { data: appointmentTypes } = useQuery({
    queryKey: [queryKeys.getAppointmentTypes],
    queryFn: () => getAppointmentTypes(),
    keepPreviousData: true,
  });
  const { data: getAppointmentsInfo, isLoading: isLoadingAppointments } =
    useQuery({
      queryKey: [queryKeys.practitioners, id],
      queryFn: () => getAppointmentsDetails(id),
      keepPreviousData: true,
      enabled: !!edit,
    });
  const patientNumber = Form.useWatch('patient', form);
  // console.log(patientNumber, 'patientNumber');
  const { data: policies } = useQuery({
    queryKey: [queryKeys.getValidPatientInsurancePolicies],
    queryFn: () => getValidPatientInsurancePolicies(patientNumber),
    select: (data) => data?.message,
    enabled: !!patientNumber,
    keepPreviousData: true,
  });
  const { data: patientData, isLoading: isLoadingPatient } = useQuery({
    queryKey: [queryKeys.patientDetails, id],
    queryFn: () => getPatientDetails(id),
    enabled: !!patient,
  });
  const { mutate: onGetDetailsPatient } = useMutation({
    mutationFn: (body) => getPatientDetails(body),
    onSuccess: (data) => {
      form.setFieldsValue({
        patient_name: data?.data?.patient_name,
        patient_sex: data?.data?.sex,
        mobile: data?.data?.mobile,
        patient_age:
          dayjs().format('YYYY') - dayjs(data?.data?.dob).format('YYYY') || 0,
      });
      // console.log(data, 'data');
    },
  });
  const { mutate: onGetPractitionersDetails } = useMutation({
    mutationFn: (id) => getPractitionersDetails(id),
    onSuccess: (data) => {
      // form.setFieldsValue({
      //   patient_name: data?.message?.message?.patient_name,
      //   patient_sex: data?.message?.message?.sex,
      //   patient_age: data?.message?.message?.age,
      // });
      setValueTime({
        practitioner: data?.data?.name,
        department: data?.data?.department,
        service_unit: data?.data?.practitioner_schedules[0]?.service_unit,
        schedule: data?.data?.practitioner_schedules[0]?.schedule,
      });
      form.setFieldsValue({
        department: data?.data?.department,
        service_unit: data?.data?.practitioner_schedules[0]?.service_unit,
        custom_schedule: data?.data?.practitioner_schedules[0]?.schedule,
      });
      // console.log(data, 'data');
    },
  });
  // console.log(patientData, 'patientData');

  const handleChangePatient = async ({ value, option }) => {
    console.log(option, 'optionmmmmmmm');
    form.setFieldsValue({
      patient_name: option?.data?.patient_name,
      patient_sex: option?.data?.sex,
      patient_age: option?.data?.age,
    });
  };
  const handleChangePractitioner = async ({ value, option }) => {
    console.log(option, 'optionmmmmmmm');
    setValueTime(option?.data);
    form.setFieldsValue({
      department: option?.data?.department,
      service_unit: option?.data?.service_unit,
      custom_schedule: option?.data?.schedule,
    });
  };
  const handleChangeTime = async ({ value, option }) => {
    onGetAvailableTimeSlots({
      practitioner: valueTime?.practitioner,
      // appointment_date: dayjs(value).format('YYYY-MM-DD'),
      date: dayjs(value).format('YYYY-MM-DD'),
      service_unit: valueTime?.service_unit,
      schedule: valueTime?.schedule,
    });
  };
  useEffect(() => {
    console.log(getAppointmentsInfo, 'getAppointmentsInfo .................. ');
    if (getAppointmentsInfo?.data) {
      const dob = dayjs(getAppointmentsInfo?.data?.patient_dob);
      console.log(dob, 'dob');
      const today = dayjs();
      const ageInYears = today.diff(dob, 'year');
      form?.setFieldValue('patient_age', ageInYears);
      setValueTime({
        practitioner: getAppointmentsInfo?.data?.practitioner,
        service_unit: getAppointmentsInfo?.data?.service_unit,
        // schedule: practitioners?.message?.message?.filter(
        //   (item) =>
        //     item?.name === getAppointmentsInfo?.data?.practitioner
        // )[0]?.schedule,
        schedule: getAppointmentsInfo?.data?.custom_schedule,
      });
      onGetAvailableTimeSlots({
        practitioner: getAppointmentsInfo?.data?.practitioner,
        date: dayjs(getAppointmentsInfo?.data?.appointment_date).format(
          'YYYY-MM-DD'
        ),
        // appointment_date: dayjs(
        //   getAppointmentsInfo?.data?.appointment_date
        // ).format('YYYY-MM-DD'),
        service_unit: getAppointmentsInfo?.data?.service_unit,
        // schedule: practitioners?.message?.message?.filter(
        //   (item) =>
        //     item?.name === getAppointmentsInfo?.data?.practitioner
        // )[0]?.schedule,
        custom_schedule: getAppointmentsInfo?.data?.custom_schedule,
      });
      form.setFieldsValue({
        department: getAppointmentsInfo?.data?.department,
        service_unit: getAppointmentsInfo?.data?.service_unit,
        custom_schedule: getAppointmentsInfo?.data?.custom_schedule,
        // custom_schedule: practitioners?.message?.message?.filter(
        //   (item) =>
        //     item?.name === getAppointmentsInfo?.data?.practitioner
        // )[0]?.schedule,
      });
    }
  }, [getAppointmentsInfo, onGetAvailableTimeSlots]);
  const items = (status) => [
    {
      key: '1',
      label: (
        // status?.workflow_state === 'Scheduled' && (
        <Button
          type="text"
          size="small"
          disabled={status?.workflow_state !== 'Scheduled'}
          onClick={() =>
            updateAppointmentStatus({ record: id, status: 'Confirm' })
          }
        >
          {t.confirm}
        </Button>
      ),
      // ),
    },

    {
      key: '2',
      label: (
        // status?.workflow_state === 'Scheduled' && (
        <Button
          type="text"
          size="small"
          disabled={status?.workflow_state !== 'Scheduled'}
          onClick={() =>
            updateAppointmentStatus({
              record: id,
              status: 'Cancel',
            })
          }
        >
          {t.Cancel}
        </Button>
      ),
      // ),
    },

    {
      key: '3',
      label: (
        // status?.workflow_state === 'Confirmed' && (
        <Button
          type="text"
          size="small"
          disabled={status?.workflow_state !== 'Confirmed'}
          onClick={() =>
            updateAppointmentStatus({
              record: id,
              status: 'Pending',
            })
          }
          loading={loadingUpdateStatus}
        >
          {t.pending}
        </Button>
      ),
      // ),
    },

    {
      key: '4',
      label: (
        // status?.workflow_state === 'Confirmed' && (
        <Button
          size="small"
          type="text"
          disabled={status?.workflow_state !== 'Confirmed'}
          onClick={() =>
            updateAppointmentStatus({
              record: id,
              status: 'Check In',
            })
          }
        >
          {t.checkIn}
        </Button>
      ),
      // ),
    },
    {
      key: '5',
      label: (
        // status?.workflow_state === 'Pending to complete patient file' && (
        <Button
          type="text"
          size="small"
          disabled={
            status?.workflow_state !== 'Pending to complete patient file'
          }
          onClick={() =>
            updateAppointmentStatus({
              record: status?.name,
              status: 'Check In',
            })
          }
        >
          {t.checkIn}
        </Button>
      ),
      // ),
    },
    {
      key: '6',
      label: (
        // status?.workflow_state === 'Checked In' && (
        <Button
          type="text"
          size="small"
          disabled={status?.workflow_state !== 'Checked In'}
          onClick={() =>
            updateAppointmentStatus({
              record: id,
              status: 'Open',
            })
          }
        >
          {t.open}
        </Button>
      ),
      // ),
    },
    {
      key: '7',
      label: (
        // status?.workflow_state === 'Open' && (
        <Button
          type="text"
          size="small"
          disabled={status?.workflow_state !== 'Open'}
          onClick={() =>
            updateAppointmentStatus({
              record: id,
              status: 'Checked Out',
            })
          }
        >
          {t.checkedOut}
        </Button>
      ),
      // ),
    },
  ];
  if (isLoadingAppointments || isLoadingPatient) {
    return (
      <div
        style={{
          width: '100%',
          height: '80vh',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Spin size="large" />
      </div>
    );
  }
  return (
    <div className="appointment-add">
      <Heading
        title={t.appointment}
        subTitle={edit ? t.editAppointment : t.addAppointment}
        status={getAppointmentsInfo?.data?.status}
        path="/appointments"
      />
      <Card>
        <Flex
          style={{
            justifyContent: 'space-between',
            alignItems: 'center',
            width: '100%',
          }}
        >
          <ChangeStauts edit={edit} status={getAppointmentsInfo} t={t} />
          {edit && (
            <Dropdown
              menu={{ items: items(getAppointmentsInfo?.data) }}
              trigger={['click']}
              arrow
              // onClick={() => setStatus(record)}
            >
              <Button
                size="small"
                type="text"
                className="btn-light"
                style={{
                  marginBottom: '20px',
                }}
              >
                {t.action}
                <DownOutlined />
              </Button>
            </Dropdown>
          )}
        </Flex>
        <Form
          layout="vertical"
          name="nest-messages"
          onFinish={onFinish}
          form={form}
          initialValues={
            edit
              ? {
                  ...getAppointmentsInfo?.data,
                  patient_age: getAppointmentsInfo?.data?.patient_age || 0,
                  custom_schedule: getAppointmentsInfo?.data?.custom_schedule,
                  //   custom_schedule: practitioners?.message?.message?.filter(
                  //   (item) =>
                  //     item?.name ===
                  //     getAppointmentsInfo?.data?.practitioner
                  // )[0]?.schedule,
                  appointment_date: dayjs(
                    getAppointmentsInfo?.data?.appointment_date
                  ),
                  appointment_time: getAppointmentsInfo?.data?.appointment_time,
                }
              : patient
              ? {
                  ...patientData?.data,
                  patient: patientData?.data?.custom_file_number,
                  patient_name: patientData?.data?.customer,
                  patient_sex: patientData?.data?.sex,
                  mobile: patientData?.data?.mobile,
                  patient_age:
                    dayjs().format('YYYY') -
                      dayjs(patientData?.data?.dob).format('YYYY') || 0,
                  //   schedule:
                  //     patientData?.data?.practitioner_name,
                  //   appointment_date: dayjs(
                  //     patientData?.data?.appointment_date
                  //   ),
                  appointment_time: patientData?.data?.appointment_time,
                }
              : {}
          }
        >
          <Row gutter={[16, 0]}>
            <Col xs={24} sm={12} md={8} lg={8}>
              <Form.Item
                name="patient"
                label={t.patientFileNumber}
                rules={[
                  {
                    required: true,
                    message: t.requiredPatientFileNumber,
                  },
                ]}
              >
                <Select
                  placeholder={t.patientFileNumber}
                  showSearch
                  popupMatchSelectWidth={false}
                  // optionFilterProp="children"
                  // filterOption={(input, option) =>
                  //   (option?.label ?? '').toLocaleLowerCase().includes(input)
                  // }
                  // filterSort={(optionA, optionB) =>
                  //   (optionA?.label ?? '')
                  //     .toLowerCase()
                  //     .localeCompare((optionB?.label ?? '').toLowerCase())
                  // }
                  // onChange={(value, option) => {
                  //   handleChange({ name: 'patient', value, option });
                  // }}
                  onChange={(value, option) =>
                    // handleChangePatient({ value, option })
                    onGetDetailsPatient(value)
                  }
                  onSearch={(value) => {
                    setSearchTxt(value);
                  }}
                  filterOption={false}
                  loading={isLoadingPatientSearch}
                  // options={patients?.message?.message?.map((item) => ({
                  //   value: item?.name,
                  //   label:
                  //     item?.custom_file_number + ' - ' + item?.patient_name,
                  //   data: item,
                  // }))}
                >
                  {patientsSearch?.message?.map((item) => (
                    <Select.Option key={item?.value} value={item?.value}>
                      <Flex gap={1} vertical>
                        <span>{item?.value}</span>
                        <span
                          className="item-description"
                          style={{ fontSize: '11px', color: 'gray' }}
                        >
                          {item?.description}
                        </span>
                      </Flex>
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} lg={8}>
              <Form.Item
                name="patient_name"
                label={t.patientName}
                // rules={[
                //   {
                //     required: true,
                //     message: t.requiredPatientName,
                //   },
                // ]}
              >
                <Input placeholder={t.patientName} disabled />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} lg={8}>
              <Form.Item
                name="patient_sex"
                label={t.gender}
                // rules={[
                //   {
                //     required: true,
                //     message: t.requiredGender,
                //   },
                // ]}
              >
                <Select
                  disabled
                  placeholder={t.gender}
                  options={[
                    {
                      value: 'Male',
                      label: t.male,
                    },
                    {
                      value: 'Female',
                      label: t.female,
                    },
                  ]}
                />
              </Form.Item>
            </Col>

            <Col xs={24} sm={12} md={8} lg={8}>
              <Form.Item
                name="patient_age"
                label={t.patientAge}
                // rules={[
                //   {
                //     required: true,
                //     message: t.requiredAge,
                //   },
                // ]}
              >
                <Input placeholder={t.patientAge} disabled />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} lg={8}>
              <Form.Item
                name="mobile"
                label={t.mobile}
                className="w-full"
                // rules={[
                //   {
                //     required: true,
                //   },
                //   {
                //     validator: (rule, value) => {
                //       console.log(value, 'value');
                //       if (isValidPhoneNumber(value)) {
                //         return Promise.resolve();
                //       }
                //       return Promise.reject('رقم الجوال غير صالح');
                //     },
                //   },
                // ]}
                hasFeedback
              >
                <PhoneInputWithCountrySelect
                  defaultCountry="SA"
                  className="w-full"
                  name="phone"
                  label={t.mobile}
                  international
                  hasFeedback
                  limitMaxLength={true}
                  disabled
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} lg={8}>
              <Form.Item
                name="appointment_type"
                label={t.appointmentType}
                rules={[
                  {
                    required: true,
                    message: t.requiredAppointmentType,
                  },
                ]}
              >
                <Select
                  placeholder={t.appointmentType}
                  options={appointmentTypes?.message?.appointment_types?.map(
                    (item) => ({
                      value: item?.name,
                      label: item?.name,
                    })
                  )}
                />
              </Form.Item>
            </Col>

            <Col xs={24} sm={12} md={8} lg={8}>
              <Form.Item
                name="practitioner"
                label={t.healthcarePractitioner}
                rules={[
                  {
                    required: true,
                    message: t.requiredPractitioner,
                  },
                ]}
              >
                <Select
                  placeholder={t.healthcarePractitioner}
                  showSearch
                  popupMatchSelectWidth={false}
                  // optionFilterProp="children"
                  // filterOption={(input, option) =>
                  //   (option?.label ?? '').toLocaleLowerCase().includes(input)
                  // }
                  // filterSort={(optionA, optionB) =>
                  //   (optionA?.label ?? '')
                  //     .toLowerCase()
                  //     .localeCompare((optionB?.label ?? '').toLowerCase())
                  // }
                  // onChange={(value) => {
                  //   handleChange({ name: 'practitioner', value });
                  // }}
                  loading={isLoadingPractitioners}
                  onSearch={(value) => {
                    setSearchPractitionerTxt(value);
                  }}
                  onChange={(value, option) =>
                    // handleChangePractitioner({ value, option })
                    onGetPractitionersDetails(value)
                  }
                  filterOption={false}
                  // options={practitioners?.message?.message?.map((item) => ({
                  //   value: item?.name,
                  //   label: item?.practitioner_name,
                  //   data: item,
                  // }))}
                >
                  {practitionersSearch?.message?.map((item) => (
                    <Select.Option key={item?.value} value={item?.value}>
                      <Flex gap={1} vertical>
                        <span>{item?.value}</span>
                        {/* <span>{item?.description}</span> */}
                        <span
                          className="item-description"
                          style={{
                            fontSize: '11px',
                            color: 'gray',
                            fontWeight: 'bold',
                          }}
                        >
                          {item?.description}
                          {/* {item?.value} */}
                        </span>
                      </Flex>
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>

            <Col xs={24} sm={12} md={8} lg={8}>
              <Form.Item
                name="department"
                label={t.department}
                rules={[
                  {
                    required: true,
                    message: t.requiredDepartment,
                  },
                ]}
              >
                <Input placeholder={t.department} disabled />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} lg={8}>
              <Form.Item
                name="custom_schedule"
                label={t.practitionerSchedule}
                rules={[
                  {
                    required: true,
                    message: t.requiredPractitionerSchedule,
                  },
                ]}
              >
                <Input placeholder={t.practitionerSchedule} disabled />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} lg={8}>
              <Form.Item
                name="service_unit"
                label={t.serviceUnit}
                rules={[
                  {
                    required: true,
                    message: t.requiredServiceUnit,
                  },
                ]}
              >
                <Input placeholder={t.serviceUnit} disabled />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} lg={8}>
              <Form.Item name="insurance_policy" label={t.insurancePolicy}>
                <Select
                  placeholder={t.insurancePolicy}
                  options={policies?.policies?.map((item) => ({
                    value: item?.name,
                    label: item?.name,
                    option: item,
                  }))}
                  onChange={(value, option) => {
                    form.setFieldsValue({
                      insurance_payor: option?.option?.insurance_payor,
                    });
                  }}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} lg={8}>
              <Form.Item
                name="insurance_payor"
                label={t.insurancePayor}
                // ]}
              >
                <Input placeholder={t.insurancePayor} disabled />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} lg={8}>
              <Form.Item
                name="appointment_date"
                label={t.appointmentDate}
                rules={[
                  {
                    required: true,
                    message: t.requiredServiceUnit,
                  },
                ]}
              >
                {/* <DatePicker
                    format="YYYY-MM-DD"
                    placeholder={t.appointmentDate}
                    style={{ width: '100%' }}
                    onChange={(date, option) =>
                      handleChangeTime({ value: date, option })
                    }
                    disabledDate={(current) =>
                      current.endOf('d').valueOf() < dayjs().endOf('d').valueOf()
                    }
                  /> */}
                <DatePicker
                  format="YYYY-MM-DD"
                  placeholder={t.appointmentDate}
                  style={{ width: '100%' }}
                  onChange={(date, option) =>
                    handleChangeTime({ value: date, option })
                  }
                  disabledDate={(current) => {
                    const isPast =
                      current.endOf('d').valueOf() <
                      dayjs().endOf('d').valueOf();
                    const isDisabledDay = disabledDays.includes(
                      current.format('YYYY-MM-DD')
                    );
                    return isPast || isDisabledDay;
                  }}
                />
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <Form.Item
                name="appointment_time"
                className="hours"
                label={t.appointmentTime}
                rules={[
                  {
                    required: true,
                    message: t.requiredAppointmentTime,
                  },
                ]}
              >
                <Radio.Group
                  defaultValue={[1]}
                  style={{ width: '100%' }}
                  className={`radio-hours ${
                    darkMode ? 'dark-radio' : 'light-radio'
                  }`}
                  // onChange={(e) => setValueHours(e.target.value)}
                >
                  {isLoading ? (
                    <Spin />
                  ) : (
                    // selectTimeSlots?.map((item) => (
                    //   <Radio
                    //     value={item?.from_time}
                    //     style={{ position: 'relative' }}
                    //     key={item?.from_time}
                    //     disabled={selectTimesNoAvailable?.includes(item?.from_time)}
                    //   >
                    //     {getTimeFormat(item?.from_time)}
                    //   </Radio>
                    // ))
                    selectTimeSlots?.map((item) => {
                      const isDisabled = selectTimesNoAvailable?.some(
                        (time) => {
                          const fromTime = dayjs(time.from_time, 'HH:mm:ss');
                          const toTime = dayjs(time.to_time, 'HH:mm:ss');
                          const currentTime = dayjs(
                            item?.from_time,
                            'HH:mm:ss'
                          );
                          return currentTime.isBetween(
                            fromTime,
                            toTime,
                            null,
                            '[]'
                          );
                        }
                      );
                      return (
                        <Radio
                          value={item?.from_time}
                          style={{ position: 'relative' }}
                          key={item?.from_time}
                          disabled={isDisabled}
                          className={isDisabled ? 'disabled-radio-time' : ''}
                        >
                          {getTimeFormat(item?.from_time)}
                        </Radio>
                      );
                    })
                  )}
                </Radio.Group>
              </Form.Item>
            </Col>
          </Row>
          <div className="form-btns">
            <Button type="primary" ghost onClick={() => navigate(-1)}>
              {t.Cancel}
            </Button>
            <Button type="primary" htmlType="submit" loading={loadingAdd}>
              {edit ? t.edit : t.submit}
            </Button>
          </div>
        </Form>
      </Card>
    </div>
  );
};

export default AppointmentAdd;
